import { render, staticRenderFns } from "./LPS.vue?vue&type=template&id=0be1062e"
import script from "./LPS.vue?vue&type=script&lang=js"
export * from "./LPS.vue?vue&type=script&lang=js"
import style0 from "./LPS.vue?vue&type=style&index=0&id=0be1062e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports